export const EVENT_TICKETS_RESET_STATE = 'EVENT_TICKETS_RESET_STATE';
export const EVENT_TICKETS_CURRENT_ITEM = 'EVENT_TICKETS_CURRENT_ITEM';

export const EVENT_TICKETS_REQUEST_LOADING = 'EVENT_TICKETS_REQUEST_LOADING';
export const EVENT_TICKETS_REQUEST_SUCCESS = 'EVENT_TICKETS_REQUEST_SUCCESS';
export const EVENT_TICKETS_REQUEST_FAILED = 'EVENT_TICKETS_REQUEST_FAILED';

export const EVENT_TICKETS_CURRENT_ACTION = 'EVENT_TICKETS_CURRENT_ACTION';
export const EVENT_TICKETS_RESET_ACTION = 'EVENT_TICKETS_RESET_ACTION';